import React from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import trash_icon from '../../../assets/images/icons/user-dashboard/trash-icon.png';
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import DOMPurify from 'dompurify';

const AcceptedJobView = (props) => {
  // if (localStorage.getItem("token")) {
  return (
    <>
      <div className="dashboard-body-area">
        <section className="findjob-search-section">
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-md-3 findjob-search-heading">
                <h2 className="cc-main_title--md">Find a job</h2>
              </div>
              <div className="col-md-8 findjob-search-bar">
                <div className="cc-searchbar">
                  <div className="srch-fld-row">
                    <div className="srch-fld-col">
                      <input type="text" placeholder="Postcode" />
                    </div>
                    <div className="srch-fld-col">
                      <select>
                        <option>Select Profession</option>
                        <option>Doctor</option>
                      </select>
                    </div>
                    <div className="srch-fld-col srch-btn-col">
                      <input
                        type="submit"
                        value=""
                        className="form-submit-btn"
                      />
                    </div>
                  </div>
                </div>
                <h5 className="job-search-info">
                  List of Jobs will apear based on the postcode given by user
                </h5>
              </div>
            </div>
          </div>
        </section>

        <section className="dashboard-page-title">
          <div className="jobs-header">
            <div className="row">
              <div className="col-lg-6">
                <h2>Accepted Job's</h2>
                <h5>Total Jobs {props.length}</h5>
                <div className="list-view" style={{ marginTop: '-19px' }}>
                  {props.list_active === 'active' ? (
                    <a
                      href=""
                      onClick={props.handelFormat}
                      className="active"
                    >
                      <i className="fa fa-bars"></i>
                    </a>
                  ) : (
                    <a href="" onClick={props.handelFormat}>
                      <i className="fa fa-bars"></i>
                    </a>
                  )}
                  {props.card_active === 'active' ? (
                    <a
                      href=""
                      onClick={props.handelFormat}
                      className="active"
                    >
                      <i className="fa fa-th-large"></i>
                    </a>
                  ) : (
                    <a href="" onClick={props.handelFormat}>
                      <i className="fa fa-th-large"></i>
                    </a>
                  )}
                </div>
              </div>
              <div className="col-lg-3 pad-left-0">
                <select className="select">
                  <option>View of Job</option>
                  <option>Popular Job 1</option>
                  <option>Popular Job 2</option>
                  <option>Popular Job 3</option>
                </select>
              </div>
              <div className="col-lg-3 pad-left-0">
                <select className="select">
                  <option>Sorting by</option>
                  <option>Popular Job 1</option>
                  <option>Popular Job 2</option>
                  <option>Popular Job 3</option>
                </select>
              </div>
            </div>
          </div>
        </section>
        {props.card ? (
          props.job_detail.map((jobs, index) => (
            <div className="job-box">
              <a
                href=""
                onClick={(e) => props.handelcompression(jobs.id)}
                className="job-expand active"
                data-id="job-1"
              ></a>
              <h2>{jobs.job_title}</h2>

              <div
                className="jobs-details"
                style={
                  props.expand_id === jobs.id
                    ? { display: props.expand }
                    : { display: 'none' }
                }
                id="job-1"
              >
                <div className="job-requirement">
                  <div className="row">
                    <div className="col-sm-3">Job ID:</div>
                    <div className="col-sm-9">
                      <strong>{jobs.job_number}</strong>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">PostCode:</div>
                    <div className="col-sm-9">
                      <strong>{jobs.job_postcode}</strong>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">Job Type:</div>
                    <div className="col-sm-9">
                      <strong>{jobs.job_type}</strong>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">Qualification:</div>
                    <div className="col-sm-9">
                      <strong>
                        {props.return_string_data(jobs.job_qualifications)}
                      </strong>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">Incentive:</div>
                    <div className="col-sm-9">
                      <strong>{jobs.job_incentive}</strong>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">Remuneration:</div>
                    <div className="col-sm-9">
                      <strong>{jobs.job_renumeration}</strong>
                    </div>
                  </div>
                </div>
                <div className="job-description">
                  <h4>Job description</h4>
                  <p>
                    <span
                      className="more"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(jobs.job_description),
                      }}
                    ></span>
                  </p>
                </div>
              </div>
              <div className="job-date">
                <span>
                  Start Date: {moment(jobs.start_date).format('DD-MM-YYYY')}
                </span>
                <span>Shift Number: {jobs.shift_number}</span>
              </div>
              <div className="job-view">
                <ul>
                  <li>
                    <i className="fa fa-eye"></i> Contact Person{' '}
                    <span>{jobs.patient_name}</span>
                  </li>
                  <li>
                    <i className="fa fa-calendar"></i> Start Time{' '}
                    <span>{jobs.start_date_arrival_time}</span>{' '}
                  </li>
                  <li>
                    <i className="fa fa-calendar"></i> End Time{' '}
                    <span>{jobs.start_date_departure_time}</span>
                  </li>
                </ul>
              </div>
              <div className="job-btn">
                <a
                  href={'/job-details/' + jobs.job + '/#applied'}
                  className="btn-white"
                >
                  Read More <i className="fa fa-angle-down"></i>
                </a>
                <a
                  href=""
                  style={{ background: '#8c8687' }}
                  className="btn-red"
                  disabled
                >
                  Booked
                </a>
                {/* <a className="btn-red">APPLY JOB <i className="fa fa-arrow-right"></i></a> */}
              </div>
              <br />
              <p>
                To cancel this shift send email to{' '}
                <a href="mailto:cancellations@carerconnect.com">
                  cancellations@carerconnect.com
                </a>{' '}
                or call the office
              </p>
            </div>
          ))
        ) : (
          <div className="table-area applied-job-table">
            {Object.keys(props.job_detail).length > 0 ? (
              <Table responsive>
                <thead>
                  <tr>
                    <th>Applied on</th>
                    <th>Title</th>
                    <th>Job Type</th>
                    <th>Job Number</th>
                    <th>Start Time</th>
                    <th>End time</th>
                    <th>Zipcode</th>
                    <th>Address</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {props.job_detail.map((jobs, index) => (
                    <tr>
                      <td>{jobs.date_applied}</td>
                      <td>{jobs.job_title}</td>
                      <td>{jobs.job_type}</td>
                      <td>{jobs.job_number}</td>
                      <td>{jobs.start_date_arrival_time}</td>
                      <td>{jobs.start_date_departure_time}</td>
                      <td>{jobs.job_postcode}</td>
                      <td>{jobs.job_city}</td>
                      <td>{jobs.status}</td>
                      <td>
                        <a
                          href=""
                          onClick={(e) => props.handledelete(jobs.job)}
                          className="del_btn"
                        >
                          <img src={trash_icon} />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : null}
          </div>
        )}
      </div>
    </>
  );
  // } else {
  //     return (
  //       <Navigate to="/login" />
  //     )
  // }
};

export default AcceptedJobView;
